const API_BASE = import.meta.env.VITE_API_BASE_URL || "";

export interface DocumentRow {
  documentId: string;
  title: string;
  description: string;
  documentType: string;
  category: string;
  visibility: string;
  uploadDate: string | null;
  status: string;
  canDownload: boolean;
  driveFileId: string | null;
}

export async function fetchAdminDocuments(): Promise<DocumentRow[]> {
  const response = await fetch(`${API_BASE}/api/admin/documents`);
  const body = await response.json();
  if (!response.ok || body.status === "error") {
    throw new Error(body?.error ?? `Request failed with ${response.status}`);
  }
  return body.data as DocumentRow[];
}

export async function deleteAdminDocument(documentId: string): Promise<void> {
  const response = await fetch(`${API_BASE}/api/admin/documents?id=${encodeURIComponent(documentId)}`, {
    method: "DELETE",
  });
  const body = await response.json();
  if (!response.ok || body.status === "error") {
    throw new Error(body?.error ?? `Request failed with ${response.status}`);
  }
}

export const DOCUMENT_CATEGORIES = [
  "Company",
  "Financial Reports",
  "Performance Reports",
  "Investment Opportunities",
  "Executive Summaries & Updates",
  "Misc Reports",
  "Contracts",
  "Correspondence",
  "Investors",
  "Guests",
  "Templates",
] as const;

export async function uploadDocument(
  file: File,
  category: string,
  title?: string,
  documentType?: string,
  description?: string
): Promise<void> {
  const form = new FormData();
  form.append("file", file);
  form.append("category", category);
  if (title) form.append("title", title);
  if (documentType) form.append("documentType", documentType);
  if (description) form.append("description", description);

  const response = await fetch(`${API_BASE}/api/admin/upload`, { method: "POST", body: form });
  const body = await response.json();
  if (!response.ok || body.status === "error") {
    throw new Error(body?.error ?? `Request failed with ${response.status}`);
  }
}
